import { library } from '@fortawesome/fontawesome-svg-core';
import { faList } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { IconButton } from '@mui/joy';
import { useInjection } from 'inversify-react';
import { ReactElement } from 'react';
import { useHistory } from 'react-router';
import { ICurrentWorkspaceStore } from '../../../../modules/workspaces/currentWorkspace/CurrentWorkspace.store';
import { Home } from '../../../routes/config/Home';

library.add(faList);

export const GoToWorkspacesButtonContainer = (): ReactElement => {
  const history = useHistory();
  const currentWorkspaceStore = useInjection(ICurrentWorkspaceStore.$);

  const { t } = useTranslator();

  const goToWorkspaces = (): void => {
    history.push(Home.Workspaces.List.withParams({ workspaceId: currentWorkspaceStore.currentWorkspace.id }));
  };

  return (
    <div>
      <IconButton
        variant='topbar'
        onClick={goToWorkspaces}
        title={t('go_to_workspaces')}
      >
        <FontAwesomeIcon icon={faList} />
      </IconButton>
    </div>
  );
};
